module.exports = __webpack_public_path__ + "img/bond-process-auction.f53c6bce.png";